const SpacingsFoundationsZiniaThemes = {
    spacing_0: '0rem',
    spacing_25: '0.063rem',
    spacing_50: '0.125rem',
    spacing_100: '0.25rem',
    spacing_150: '0.5rem',
    spacing_200: '0.625rem',
    spacing_250: '0.75rem',
    spacing_300: '1rem',
    spacing_350: '1.25rem',
    spacing_400: '1.5rem',
    spacing_450: '2rem',
    spacing_500: '2.5rem',
    spacing_550: '3rem',
    spacing_600: '3.5rem',
    spacing_650: '4rem',
    spacing_675: '4.5rem',
    spacing_700: '5rem',
    spacing_740: '7.5rem',
    spacing_750: '8rem',
    spacing_800: '8.5rem',
    // percentages
    spacing_100_percent: '100%',
    spacing_50_percent: '50%',
    spacing_70_percent: '70%',
    spacing_30_percent: '30%',
    spacing_25_percent: '25%',
    spacing_20_percent: '20%',
    spacing_10_percent: '10%',
    spacing_5_percent: '5%',
    // window
    spacing_100_vh: '100vh',
    spacing_100_vw: '100vw',
    // px
    spacing_100_px: '4px',
    spacing_180_px: '180px',
};
export { SpacingsFoundationsZiniaThemes };
//# sourceMappingURL=spacings-foundations.zinia.themes.js.map